import { Tooltip } from '@/components/basicComponents/tooltip';
import DropdownActions from '@/components/table/dropdownActions';
import NoResults from '@/components/table/noResults';
import { TableRowCell, TableRowWrapper, TextCell } from '@/components/table/styles';
import { IItems } from '@/components/table/types';
import { getTimezoneDate, isValidDate } from '@/shared/utils/date';
import { ROLE } from '@trace-8/trace8-schema';
import { format } from 'date-fns';
import styled from 'styled-components';
import { firmTableColumns } from '../constants';
import { IUser } from '../types';

export const formatUserPhoneNumber = (countryCode: string, number: string, defaultValue: string = '') => {
  if (!countryCode || !number) return defaultValue;
  return `(+${countryCode || ''}) ${number || ''}`;
};

interface TableBodyProps {
  firmTableTableData: IUser[];
  flashUpdatingRow: string;
  actionsByStatus: (row: IUser) => IItems[];
}

const TableBody = ({ firmTableTableData, flashUpdatingRow, actionsByStatus }: TableBodyProps) => {
  if (!firmTableTableData?.length) {
    return <NoResults />;
  }

  return (
    <>
      {firmTableTableData.map((user: IUser) => {
        const lastLoginDate = new Date(user.lastLogin);
        const isLastLoginValidDate = isValidDate(lastLoginDate);
        const convertedLastLogin = isLastLoginValidDate ? getTimezoneDate(lastLoginDate) : null;
        const formattedLastLogin = isLastLoginValidDate ? format(lastLoginDate, 'MMM d, yyyy') : null;
        const tz_shorthand = lastLoginDate.toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];

        return (
          <TableRowWrapper key={user.id} loading={flashUpdatingRow === user.id ? 1 : 0}>
            <TableRowCell width={firmTableColumns[0].width}>
              <EmailCell>{user.email}</EmailCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[1].width}>
              <TextCell>
                {user.lastLogin && isLastLoginValidDate && (
                  <Tooltip title={`${formattedLastLogin} ${format(lastLoginDate, 'h:mm a')} ${tz_shorthand}`}>{formattedLastLogin}</Tooltip>
                )}
                {user.lastLogin && !isValidDate(new Date(user.lastLogin)) && user.lastLogin}
              </TextCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[2].width}>
              <TextCell>{user.firstName}</TextCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[3].width}>
              <TextCell>{user.lastName}</TextCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[4].width}>
              <TextCell>{formatUserPhoneNumber(user?.mobilePhoneNumber?.countryCode, user?.mobilePhoneNumber?.number)}</TextCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[5].width}>
              <TextCell>
                {user?.roles?.length > 1 ? (
                  <Tooltip
                    title={user.roles
                      .map((role) => ROLE[role])
                      .toString()
                      .replace(/,/g, ', ')}
                  >
                    Multiple ({user.roles.length})
                  </Tooltip>
                ) : (
                  user?.roles && ROLE[user.roles[0]]
                )}
              </TextCell>
            </TableRowCell>
            <TableRowCell width={firmTableColumns[6].width}>
              {!!actionsByStatus(user)?.length && <DropdownActions items={actionsByStatus(user)} />}
            </TableRowCell>
          </TableRowWrapper>
        );
      })}
    </>
  );
};

export default TableBody;

export const EmailCell = styled(TextCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
